import React from 'react';
import backIcon from '../../assets/images/back-arrow.svg';
import { Image } from './BackButton.styles';
import { Link } from 'react-router-dom';

const BackButton = () => (
  <Link to="/">
    <Image src={backIcon} />
  </Link>
);

export default BackButton;
